import { useTranslation } from 'react-i18next'

import { useErrorInfoModal } from '@features/modal'

import { useLogoutMutation } from '@shared/generated'
import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

import LeaveIcon from '/icons/leave.svg'

export default function LogoutButton () {
  const { openErrorInfoModal } = useErrorInfoModal()
  const [ fetchLogout ] = useLogoutMutation()
  const { t: tc } = useTranslation('auth')
  const { t: te } = useTranslation('errors')

  const handleClick = async () => {
    try {
      await fetchLogout()
      window.location.href = '/'
    }
    catch (error) {
      openErrorInfoModal({
        description: te('logout_error'),
      })
      console.error('Fetch logout error', error)
    }
  }

  return (
    <button
      className={cn('reset-button', styles.root)}
      type="button"
      onClick={handleClick}
    >
      <img src={LeaveIcon} alt="" />
      {tc('logout.button')}
    </button>
  )
}
